import api, { handleError } from "./index";

export function getProductReviews({ sku, page = 0 }) {
  return api({
    method: "get",
    url: `/product/review?store=cornerstone&sku=${sku}&page=${page}&per_page=20&comments_only=true`,
  })
    .then((response = {}) => {
      return { error: null, data: response.data };
    })
    .catch((error) => {
      const errorPayload = handleError(error);
      return {
        ...errorPayload,
        data: null,
      };
    });
}
